// QUÉ LE FALTA AL FORMULARIO DE «DAR DE ALTA» (11-10-2026).
//
// El botón se apagaba sin decir por qué: sin fecha en «Acceso hasta» y sin marcar «De
// cortesía», quien daba el alta se quedaba mirando un botón gris. La regla de cuándo se
// puede dar de alta es la que había (correo, plan y fecha o cortesía; el nombre no es
// obligatorio) y vive AQUÍ una vez: el botón se enciende cuando esto devuelve null, y la
// frase que se enseña debajo es lo que devuelve.
//
// Y UNA FECHA QUE YA PASÓ TAMPOCO VALE (12-10): se aceptaba sin avisar y ese cliente nacía
// caducado. `hoy` es el día de quien da el alta (`hoyLocal()`, AAAA-MM-DD); el servidor
// repite la comprobación con el día de España.
// «PAGO 4 SEMANAS» SIEMPRE SE RENUEVA SOLO (Francisco, 16-10, backend `core/pago_en_tramos`):
// con él la casilla «Se renueva solo» no se elige, va puesta. Lo preguntan el formulario y
// la regla de abajo.
export const PAGO_EN_TRAMOS = '4';
export const seRenuevaSolo = (form) => !!(form?.recurrente || form?.pagoSemanas === PAGO_EN_TRAMOS);
// ¿Se cobra en tramos? Solo si el plan lo admite (`/plans`, `pago_en_tramos`) y se eligió
// «Pago 4 semanas». Lo usan el alta y el tablero de leads.
export const pagaEnTramos = (planCatalog, plan, pagoSemanas) =>
    !!planCatalog?.[plan]?.pago_en_tramos && pagoSemanas === PAGO_EN_TRAMOS;

export const loQueFaltaEnElAlta = (form, hoy) => {
    const f = form || {};
    if (!(f.email || '').trim()) return 'Falta el correo.';
    if (!f.plan) return 'Falta elegir el plan.';
    // COBRAR CON ENLACE (15-10): la fecha la pone el pago el día que pague. Desde el 16-10 se
    // puede corregir la sugerida (Francisco: «que me sugiera la fecha pero que me deje
    // corregir»): sin fecha vale, pero una que ya pasó no. Con «Se renueva solo» las fechas
    // las marca Stripe y no se miran.
    if (f.conEnlace) {
        if (!seRenuevaSolo(f) && f.hasta && hoy && f.hasta < hoy) return 'Esa fecha de acceso ya pasó: pon una de hoy en adelante.';
        return null;
    }
    if (!f.cortesia && !f.hasta) return 'Falta la fecha de acceso, o marca que es de cortesía.';
    if (!f.cortesia && hoy && f.hasta < hoy) return 'Esa fecha de acceso ya pasó: pon una de hoy en adelante.';
    return null;
};
